!<template>
    <div class="m-roles">
        <el-card class="elCard">
            <div slot="header" class="clearfix m-page-title">
                <span>角色管理</span>
            </div>
            <div class="m-search">
                <el-form ref="searchForm" class="search-form" :inline='true' :model="forms">
                    <el-form-item prop="roleName">
                        <el-input placeholder="请输入角色名称" v-model="forms.roleName" clearable class="w_220"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <span  @click="search" class="search-btn"></span>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <span  @click="reset" class="reset-btn"></span>
                        </el-tooltip>
                    </el-form-item>
                </el-form>
                <div class="rt-btns">
                    <el-button  @click="edit('add')" class="button btnNew" v-if="$_auth('role_add')">创建角色</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableList" v-loading='load'  class="tableV1 m-t-0 c-table"  row-key="id" tooltip-effect="light">
                    <el-table-column  prop="roleName" label="角色名称" align="center"  width='200'></el-table-column>
                    <el-table-column  prop="userName"  label="关联子账号姓名" align="center" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column  prop="cz"  label="操作" align='center'  width='120'>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" class="cz-btn" style="color:#1ab394"  v-if="$_auth('role_modify')" @click.stop="edit('edit', scope.row.id, scope.row)">编辑</el-button>
                            <span class="cz-btn" v-if="$_auth('role_modify') && $_auth('role_delete')">|</span>
                            <el-button type="text" size="small" class="cz-btn red-font" v-if="$_auth('role_delete')" @click="del(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-page  :sizeChange='sizeChange' :currentChange='currentChange' :pageConfig='pageConfig' ></el-page>
        </el-card>
    </div>
</template>

<script>
import API from '@/fetch/api'
import * as access from '@/config/access';
import popup from '@/common/plugin/dialog'
import editDialog from './editDialog'


export default {
    data(){
        return {
            forms: {
                roleName: '',
                parkId: access.storage('projectId') || '',  
                pageSize: 10,
                pageNumber: 1
            },
            m_editDialog: null,
            tableList: [],
            load: false,
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNumber: 1,
                pageSizes: [10, 20],
                layout: 'slot,sizes, prev, pager, next, jumper'
            },
            permsList: [],
        }
    },
    created(){
        this.queryPerms();
    },
    mounted(){
        this.search();
    },
    methods: {
        reset(){
            this.$refs.searchForm.resetFields();
        },
        loading(bool = false){
            this.load = bool;
        },
        search(){
            let vm = this;
            vm.loading(true);
            API.http({ url: '/merchant/role/list', type: 'post',
                params: vm.forms
            }).then(res => {
                vm.loading();
                if(res.code == "200") {
                    let list = res.data.dataList;
                    for(let i = 0; i < list.length; i++){
                        let userList = [];
                        if(list[i].userList){
                            for(let k = 0; k < list[i].userList.length; k++){
                                userList.push(list[i].userList[k].realName);
                            }
                        }
                        list[i]['userName'] = String(userList);
                    }
                    vm.tableList = list;
                    vm.pageConfig.total = res.data.total;
                    return;
                }
                this.$showAlert(res.message || '查询失败，请稍后重试！', "error");
            }).catch(error => {
                vm.loading();
            })
        },
         //分页
        sizeChange(val) {
            let vm = this;
            vm.pageConfig.pageNumber = 1;
            vm.forms.pageNumber = 1;
            vm.pageConfig.pageSize = val;
            vm.forms.pageSize = val;
            vm.search();
        },
        currentChange(val) {
            let vm = this;
            vm.pageConfig.pageNumber = val;
            vm.forms.pageNumber = val;
            vm.search();
        },
        queryPerms(){
            let vm = this;
            API.http({ url: '/merchant/perms/list', type: 'post',
                params: vm.forms
            }).then(res => {
                if(res.code == "200") {
                    /* // 设置子菜单全部禁用
                    for(let i = 0; i < res.data.length; i++){
                        if(res.data[i].childList.length < 1) continue;
                        for(let k = 0; k < res.data[i].childList.length; k++){
                            res.data[i].childList[k].disabled = true;
                            if(res.data[i].childList[k].childList < 1) continue;
                            for(let j = 0; j < res.data[i].childList[k].childList.length; j++){
                                res.data[i].childList[k].childList[j].disabled = true;
                            }
                        }
                    } */
                    
                    vm.permsList = res.data || [];
                    return;
                }
                vm.queryPerms()
            }).catch(()=>{
                vm.queryPerms()
            })
        },
        edit(editType, id, row){
            let vm = this, initData = {};
            vm.editType = editType;
            if(!id && editType == 'edit') {
                vm.$showAlert('操作失败，缺少角色id', 'error');
                return;
            }
            if(editType == 'add'){
                vm.showDialog(editType, {});
                return;
            }
            vm.loading(true);
            API.http({ url: '/merchant/role/perms', type: 'post',
                params: { roleId: id }
            }).then(res => {
                vm.loading();
                if(res.code == 200) {
                    initData = { 
                        roleId: id,
                        roleName: row.roleName || '',
                        remark: row.remark || "",
                        permissionIds: res.data
                    };
                    /* initData = { 
                        roleId: 8,
                        roleName: 'zmt-test' || '',
                        remark: 'zmt-test1' || "",
                        permissionIds: res.data
                    }; */
                    vm.showDialog(editType, initData);
                    return;
                }
                vm.$showAlert('获取角色权限列表失败，请重试', 'error');
            }).catch(error => {
                vm.loading();
                vm.$showAlert('获取角色权限列表失败，请重试', 'error');
            })
        },
        showDialog(editType, initData){
            let vm = this;
            vm.m_editDialog = popup('<edit-dialog @close="close" @ok="submit" :edit-type="editType" :init-data="initData" :perms-list="permsList"/>', {
                option: {
					width: '600px',
					title: editType == 'add' ? '新建角色' : '编辑角色'
                },
                popup: {
                    data(){
                        return {
                            initData,
                            editType: vm.editType,
                            permsList: vm.permsList
                        }
                    },
                    components: {
                        editDialog 
                    },
                    methods: {
						submit(){
                            vm.m_editDialog.hide();
                            vm.search();
						},
                        close(data){
                            vm.m_editDialog.hide();
                        }
                    }
                }
            });
            vm.m_editDialog.show();
        },
        del(id){
            let vm = this;
            if(!id) {
                vm.$showAlert('操作失败，缺少角色id', 'error');
                return;
            }
            vm.loading(true);
            API.http({ url: '/merchant/role/delete', type: 'post',
                params: {
                    roleId: id
                }
            }).then(res => {
                vm.loading();
                if(res.code == "200") {
                    vm.$showAlert('删除成功', 'success');
                    vm.search();
                    return;
                }
                this.$showAlert(res.message || '删除失败，请重试！', "error");
            }).catch(error => {
                vm.loading();
                this.$showAlert(res.message || '删除失败，请重试！', "error");
            })
        }
    }

}
</script>

<style lang="scss" >
    .m-roles{
        // 搜索框
        .el-card__body{
            padding: 0;
        }
        .search_bar{
            margin-right: 20px;
            .search-form{
                float: left;
            }
            .rt-btns{
                float: right;
            }
        }
        // 表格
        .m-table{
            margin-top: 0;
            /* .vh-center{
                width: 100%;
                .image-view{
                    width: 40px;
                    height: 40px;
                    margin: 8px 0;
                }
            } */
            // 表格操作栏
            .cz-btn{
                color: #1ab394;
            }

        }
    }
</style>
